(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tabpanel", [], factory);
	else if(typeof exports === 'object')
		exports["tabpanel"] = factory();
	else
		root["tabpanel"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 